import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { ThemeContext } from "../../Context/theme";


export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="about" className="about section">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img
                class="home-img"
                src="https://avatars.githubusercontent.com/u/101381281?v=4"
                alt="Images"
              />
            </div>
            <div id="user-detail-intro">
              <h4 id="user-detail-intro">
                {/* Hi Everyone, I am{" "}
                <span className="different">Vivek Kumar Gupta </span>
                an aspiring and determined Full Stack Web Developer curious to explore different industry standard tech stacks and environments. Skilled in the MERN stack and willing to start a career with an organization that provides an opportunity to improve skills and knowledge gained as well as to grow along with the organization’s goal.
                 */}
                 Dynamic <span>Full Stack Web Developer</span> with a expertise in the MERN stack, proficient in integrating real-time communication features with socket.js and WebRTC. Skilled in implementing comprehensive unit tests with Jest, and Mocha. Collaborative team player experienced in effective task management using JIRA. Ready to drive innovation and excellence in your team

              </h4>
              <h4>
                Some of my interests apart form Coding :
              </h4>
              {/* <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                eSports Enthusiast{" "}
              </h4> */}
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Chess Enthusiast{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Travelling{" "}
              </h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
